export enum HttpResponseCodesEnum {

    /**
     * Angular uses 0 when the request never reached (or never got an answer from) the server:
     * offline, blocked, aborted or a timeout on the network
     */
    NoConnection = 0,

    /**
     * The requested data does not exist OR you are not allowed to see it
     */
    NotFound = 404,

    /**
     * We use this when the user has insufficient Credits for the requested "Action"
     */
    PaymentRequired = 402,

    /**
     * The current state of the data does not allow the requested "Action" (for example: a request that is already sent)
     */
    Conflict = 409,

    /**
     * Something went wrong on the server
     */
    InternalServerError = 500,

    /**
     * The gateway did not get an answer from the server in time, the action itself CAN still be running
     */
    GatewayTimeout = 504,
}
